export const COOKIE_KEY = { AUTH: "auth", REFRESH_TOKEN: "refreshToken" }

/**
 * AmazonPayのセッションIDと称号するためのcookieのキー
 */
export const AMAZON_PAY_COOKIE_SESSION_ID_KEY = "sessionIdForAmazonPay"
